// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D4hth","left":"styles_left__3QGi1"};